// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.toast[data-v-495e84b4] {\n   box-sizing: border-box;\n   position: fixed;\n   padding: 10px;\n   z-index: 99;\n left: 50%;\n top: 50%;\n   transition: all .3s ease;\n   border-radius: 6px;\n   background: rgba(0, 0, 0, 0.7);\n   color: #fff;\n   text-align: center;\n transform: translate(-50%,-50%);\n}\n.toast-msg[data-v-495e84b4] {\n     text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
